import Link from 'next/link';
import React, { PropsWithChildren } from 'react';

import Typography from '@/components/typography';

import { SearchResultsHeader } from './searchResultsHeader';

type Props = PropsWithChildren & {
  title: string;
  loading?: boolean;
  noResults?: boolean;
  seeMoreResults?: {
    count: number;
    url: string;
  };
};

export const SearchResultsSection: React.FC<Props> = ({
  title,
  loading = false,
  noResults = false,
  seeMoreResults = undefined,
  children = undefined,
}) => {
  return (
    <div className="flex flex-col py-1">
      <SearchResultsHeader loading={loading}>{title}</SearchResultsHeader>

      {children}

      {noResults && !loading && (
        <Typography className="px-4 py-1 text-gray-50" variant="body2">
          0 results
        </Typography>
      )}

      {seeMoreResults && !!seeMoreResults.count && seeMoreResults.count > 5 && (
        <Link
          className="group text-green-50 hover:no-underline"
          href={seeMoreResults.url}
        >
          <div className="flex justify-between px-4 py-1">
            <Typography className="text-gray-50" variant="body2">
              {seeMoreResults.count} results
            </Typography>
            <Typography className="group-hover:underline" variant="button2">
              See More
            </Typography>
          </div>
        </Link>
      )}
    </div>
  );
};
